import { useContext } from 'react';

import { StoreContext } from 'context/StoreContext';
import { RootStore } from 'store/RootStore';

export const useStore = (): RootStore => useContext(StoreContext);
